import React, {useContext, useRef, useState} from "react";
import {useFormik} from "formik";
import Button from "../Button";
import CharactersModal from "../modals/CharactersModal";
import BottomButtonWrapper from "../BottomButtonWrapper";
import {Reoverlay} from "reoverlay";
import * as Yup from "yup";
import {persianToEnglish} from "../../tools/helpers";
import Swal from "sweetalert2";
import ServiceModal from "../modals/ServiceModal";
import InsuranceCardImage from "../../images/guide/InsuranceCard.png";
import CarInfoImage from "../../images/carService/car_info_image.png"
import UserInfoImage from "../../images/carService/user_info_image.png"
import Switch from "react-switch";
function showInput(inputName,processInfo){
    switch(inputName){
        case "insurance":{
            return !!processInfo?.selected_items.includes('InsuranceInquiry')|| !!localStorage.getItem('insuranceSelected');

        }
        case "nid":{
            return !processInfo?.reseted_step || processInfo.reseted_step === "Shahkar";
        }
        case "plaque":{
            return !processInfo?.reseted_step || (processInfo?.reseted_step === "Shahkar" || processInfo?.reseted_step === "CarCardInquiry");
        }
        case "mobile":{
            return !processInfo?.reseted_step || processInfo?.reseted_step === "Shahkar";
        }
    }
}
const GetInfoCarInfo = ({handlePrev, selectedServices, handleCarCardReader, handleConfirm, processInfo}) => {
    const inputRefs = useRef([]);
    const [input1, setInput1] = useState(processInfo?.plate[0]);
    const [input2, setInput2] = useState(processInfo?.plate[1]);
    const [input3, setInput3] = useState(processInfo?.plate[2]);
    const [input4, setInput4] = useState(processInfo?.plate[3]);
    const [insuranceCheck, setInsuranceCheck] = useState(false)
    const reset_step = processInfo?.reseted_step;
    const showNidAndPlaque =!reset_step || reset_step === 'CarCardInquiry' || processInfo.passed_steps.length === 0
    const showInsurance = processInfo?.selected_items.includes("InsuranceInquiry") || !!localStorage.getItem('insuranceSelected');
    const [carCardStep, setCarCardStep] = useState(1);
    const [carInfo, setCarInfo] = useState(null)
    const [isOwner, setIsOwner] = useState((processInfo.im_owner===null || processInfo.im_owner===undefined)?true:processInfo.im_owner);

    const handleOwner = (value) => {
        if(value){
            UserInfoFormik.setFieldValue('mobile',processInfo?.platform_user)
        }else {
            UserInfoFormik.setFieldValue('mobile','')
        }
        setIsOwner(value)
    }

    const CarInfoSchema = Yup.object().shape({
        ...(showInsurance && {
            insurance: Yup.string().required("شناسه یکتا الزامی می باشد.").test("isNumber", "  شناسه یکتا بیمه  عددی می باشد", (value) => {
                if (!value || value.length === 0) {
                    return true;
                } else {

                }
                return !isNaN(persianToEnglish(value))
            }),
        })

    });
    const userInfoSchema = Yup.object().shape({
        ...(showNidAndPlaque && {
            nid: Yup.string().min(10, 'کد‌ملی ۱۰ رقم دارد.').max(10, 'کد‌ملی ۱۰ رقم دارد.').required('کد ملی الزامیست').test("isNumber", "کد ملی  عددی می باشد", (value) => {
                if (!value) {
                    return false
                }
                return !isNaN(persianToEnglish(value))
            })
        }),
        mobile: Yup.string().required('شماره موبایل مالک خودرو الزامیست.').min(11, 'شماره موبایل 11 رقم می باشد.').max(11, 'شماره موبایل 11 رقم می باشد.').test("isNumber", "  شماره تلفن همراه عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        })

    });
    const handleInputChange = (event, index) => {
        const {key, target} = event;
        switch (index) {
            case 0: {
                if (key === 'Backspace' && input1.length > 0) {

                    setInput1(input1.slice(0, -1))

                } else if (key === 'Delete' && input1.length === 0) {

                }
                break;
            }
            case 1: {

                if (key === 'Backspace' && input2.length > 0) {
                    setInput2(input2.slice(0, -1))

                } else if (key === 'Backspace' && input2.length === 0) {
                    inputRefs.current[index - 1].focus();
                }
                break;
            }
            case 2: {
                if (key === 'Backspace' && input3.length > 0) {
                    setInput3(input3.slice(0, -1))

                } else if (key === 'Backspace' && input3.length === 0) {
                    inputRefs.current[index - 1].focus();
                }

                break;
            }
            case 3: {
                if (key === 'Backspace' && input4.length > 0) {
                    setInput4(input4.slice(0, -1))

                } else if (key === 'Backspace' && input4.length === 0) {
                    inputRefs.current[index - 1].focus();
                }
                break;
            }
            default: {

            }
        }


    };
    const handleCarInfo = (values) => {
        if (insuranceCheck && (!values.insuranceNid || values.insuranceNid.length != 10)) {
            Swal.fire({
                text: 'پلاک بیمه کننده را وارد کنید.',
                title: "خطا",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: false,
                confirmButtonColor: '#d51e3e',
                confirmButtonText: 'بستن',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {


                } else {

                }
            });
            return;
        }
        if ((!reset_step || reset_step === "CarCardInquiry") && (input1.length !== 2 || input2.length !== 1 || input3.length !== 3 || input4.length !== 2)) {
            Swal.fire({
                text: 'فیلد پلاک خودرو الزامی می باشد.',
                title: "خطا",
                icon: 'error',
                backdrop: true,
                focusConfirm: false,
                showCancelButton: false,
                confirmButtonColor: '#d51e3e',
                confirmButtonText: 'بستن',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {


                } else {

                }
            })
            return
        }
        const data = {
            items: [],
            PlateNumber: [persianToEnglish(input1), persianToEnglish(input2), persianToEnglish(input3), persianToEnglish(input4)],
            InsuranceId: (values.insurance && values.insurance.length > 0) ? persianToEnglish(values.insurance) : null,
            InsuranceNationalId: insuranceCheck ? (values.insuranceNid && values.insuranceNid.length > 0) ? persianToEnglish(values.insuranceNid) : processInfo?.confirmed_data?.InsuranceNationalId : processInfo?.confirmed_data?.InsuranceNationalId,

        };
        if (selectedServices) {
            selectedServices.forEach((service) => {
                if (service.isSelected || service.default_selected) {
                    data.items.push(service.name);

                }
            })
        }
        if (processInfo.passed_steps.includes('Shahkar')) {
            handleConfirm(data)
        } else {
            setCarInfo(data);
            setCarCardStep(carCardStep + 1)
        }

    }
    const handleSubmit = (values) => {
        const data={
            ...carInfo,
            Mobile: persianToEnglish(values.mobile),
            NationalId: persianToEnglish(values.nid),
            InsuranceNationalId: carInfo.InsuranceNationalId ? persianToEnglish(carInfo.InsuranceNationalId) : values.nid? persianToEnglish(values.nid) : persianToEnglish(processInfo?.confirmed_data?.InsuranceNationalId),
            "im_owner": isOwner,
            "i_have_access_to_owner": !isOwner,
        };
        handleConfirm(data)



    }
    const PlaqueChange = (index, e) => {
        const {value, key} = e.target;

        switch (index) {
            case 0: {

                if (value && value.length === 2) {

                    inputRefs.current[index + 1].focus();
                }

                if (value.length < 3) {
                    if (!isNaN(persianToEnglish(value)))
                        setInput1(persianToEnglish(value))
                }
                break;
            }
            case 1: {

                if (value && value.length === 1) {
                    inputRefs.current[index + 1].focus();
                }
                if (value.length < 2) {

                    setInput2(persianToEnglish(value))
                }
                break;
            }
            case 2: {

                if (value && value.length === 3) {
                    inputRefs.current[index + 1].focus();
                }
                if (value.length < 4) {
                    if (!isNaN(persianToEnglish(value)))
                        setInput3(persianToEnglish(value))
                }
                break;
            }
            case 3: {
                if (value.length < 3) {
                    if (!isNaN(persianToEnglish(value)))
                        setInput4(persianToEnglish(value))
                }
                if (value && value.length === 2) {

                } else {

                }
                break;
            }
            default: {

            }
        }
    };
    const handleSelectCharacter = (value) => {
        setInput2(value);
        inputRefs.current[2].focus();
    }
    const openModal = () => {
        Reoverlay.showModal(CharactersModal, {
            onSelect: handleSelectCharacter
        })
    }
    const formik = useFormik({
        initialValues: {
            nid: '',
            ...(showInsurance && {insurance: processInfo.confirmed_data?.InsuranceId || ''}),
            ...(showInsurance && insuranceCheck && {insuranceNid: processInfo.confirmed_data?.InsuranceNationalId || ''})
        },
        validationSchema: CarInfoSchema,
        onSubmit: handleCarInfo
    });
    const UserInfoFormik = useFormik({
        initialValues: {
            nid: processInfo.confirmed_data.NationalId,
            mobile: processInfo.confirmed_data.Mobile || processInfo.platform_user,

        },
        validationSchema: userInfoSchema,
        onSubmit: handleSubmit
    });

        const handleShowInsuranceInfo = () => {
            const service = {
                faName: '',
                guide: 'کد یکتا، عددی است که بر روی بیمه شخص ثالث شما درج شده است.'
            }
            Reoverlay.showModal(ServiceModal, {service, img: InsuranceCardImage})
        }
        return <div>
            {carCardStep === 1 && <div>

                <div className="flex  justify-center items-center mb-5 border-b pb-5 w-full flex-col">
                    <img className="w-16 h-auto" src={CarInfoImage} alt=""/>
                    <span className="font-bold mt-2">اطلاعات خودرو را وارد کنید.</span>

                </div>
                <div className=" p-5 flex flex-col items-start justify-start bg-white mb-28 rounded-lg">

                    {(showInput('plaque',processInfo)) && <>
                        <span>پلاک خودرو را وارد کنید</span>
                        <div dir="ltr"
                             className="bg-white border  mt-1  w-full plaque-card  overflow-hidden rounded-xl grid grid-cols-12 gap-4  ">
                            <div
                                className="h-full bg-blue-900 flex-col  flex justify-center items-center   border-b border-gray-200  col-span-3">

                                <div className="w-full justify-start items-start px-3  flex-col flex">
                                    <div className=" flex flex-col  ">
                                        <div className="bg-green-600 w-4 h-1"/>
                                        <div className="bg-white w-4 h-1"/>
                                        <div className="bg-red-600 w-4 h-1"/>
                                    </div>
                                    <span className="text-white mt-2  text-xs ">IRAN</span>

                                </div>
                            </div>
                            <div className="h-full col-span-2 flex items-end">
                                <input onKeyDown={(event) => handleInputChange(event, 0)} value={input1}
                                       ref={(inputRef) => (inputRefs.current[0] = inputRef)} onChange={(e) => {
                                    PlaqueChange(0, e)
                                }} dir="ltr" placeholder="--"
                                       className="text-center h-full  w-full outline-none      border-gray-200 "
                                       type="tel"/>
                            </div>
                            <div className="h-full col-span-2 flex items-end">
                                <input onKeyDown={(event) => handleInputChange(event, 1)} onFocus={openModal}
                                       readOnly
                                       value={input2} ref={(inputRef) => (inputRefs.current[1] = inputRef)}
                                       onChange={(e) => {
                                           PlaqueChange(1, e)
                                       }} dir="ltr" placeholder="-"
                                       className="h-full text-center w-full  outline-none    border-gray-200 "
                                       type="text"/>
                            </div>
                            <div className="h-full col-span-3 flex items-end">
                                <input onKeyDown={(event) => handleInputChange(event, 2)} value={input3}
                                       ref={(inputRef) => (inputRefs.current[2] = inputRef)} onChange={(e) => {
                                    PlaqueChange(2, e)
                                }} dir="ltr" placeholder="---"
                                       className="h-full text-center w-full  outline-none    border-gray-200 "
                                       type="tel"/>
                            </div>

                            <div className="h-full col-span-2 flex items-end">
                                <input onKeyDown={(event) => handleInputChange(event, 3)} value={input4}
                                       ref={(inputRef) => (inputRefs.current[3] = inputRef)} onChange={(e) => {
                                    PlaqueChange(3, e)
                                }} dir="ltr" placeholder="--"
                                       className="h-full text-center w-full outline-none   border-l  border-gray-200 "
                                       type="tel"/>
                            </div>

                        </div>
                    </>}
                    <form onSubmit={formik.handleSubmit} className="w-full mt-5 ">
                        <div className="grid grid-cols-1 w-full gap-3 ">

                            {
                                (!reset_step || reset_step === 'InsuranceInquiry' || processInfo.passed_steps.length === 0) && <>

                                    {
                                        selectedServices.map((item, index) => {

                                            if (item.name === "InsuranceInquiry" && (item.isSelected || item.default_selected)) {
                                                return <div className="w-full" key={index}>
                                                    <div className="flex justify-between">
                                                        <label htmlFor="insurance">کد یکتا بیمه شخص ثالث</label>
                                                        <button type="button" className="text-sm text-blue-500"
                                                                onClick={handleShowInsuranceInfo}>راهنما
                                                        </button>
                                                    </div>
                                                    <input dir="ltr" onChange={formik.handleChange}
                                                           value={formik.values.insurance} type="tel"
                                                           className="w-full bg-gray-100  text-right rounded-xl p-3"
                                                           placeholder="کد یکتا بیمه شخص ثالث را وارد کنید"
                                                           name="insurance"/>
                                                    {formik.errors.insurance && formik.touched.insurance ? (
                                                        <p className="text-red-400 font-light mt-1 text-sm">{formik.errors.insurance}</p>
                                                    ) : null}
                                                    <div className="flex justify-between mt-2 ">
                                                        <label className="text-sm" htmlFor="insurance">کد ملی مالک خودرو
                                                            با کد
                                                            ملی بیمه نامه تطابق ندارد.</label>
                                                        <Switch onColor="#36b570" onChange={(checked) => {
                                                            setInsuranceCheck(checked)
                                                            if (checked) {
                                                                formik.setFieldValue('insuranceNid', '')
                                                            }

                                                        }} dir="rtl" size={50} checkedIcon={false} uncheckedIcon={false}
                                                                height={20} width={40} checked={insuranceCheck}/>
                                                    </div>
                                                    <div>
                                                        <input dir="ltr" disabled={!insuranceCheck}
                                                               onChange={formik.handleChange}
                                                               value={formik.values.insuranceNid}
                                                               type="tel"
                                                               className={`w-full bg-gray-100  text-right rounded-xl p-3 ${insuranceCheck ? '' : 'hidden'}`}
                                                               placeholder="کد ملی را وارد کنید"
                                                               name="insuranceNid"/>
                                                        {formik.errors.insuranceNid && formik.touched.insuranceNid && insuranceCheck ? (
                                                            <p className="text-red-400 font-light mt-1 text-sm">{formik.errors.insuranceNid}</p>
                                                        ) : null}
                                                    </div>
                                                </div>

                                            }
                                        })
                                    }

                                </>
                            }


                        </div>

                        <BottomButtonWrapper grid={1}>
                            <div
                                className={` justify-between grid gap-2 items-center ${(!reset_step || processInfo.passed_steps.length === 0) ? ' grid-cols-2' : 'grid-cols-1'}`}>
                                {(!reset_step || processInfo.passed_steps.length === 0) &&
                                    <Button onClick={handlePrev} type="button" rounded="rounded-lg"
                                            className="w-full  text-sm flex justify-center items-center"
                                            theme="link"><span>بازگشت</span></Button>}
                                <Button type="submit" rounded="rounded-lg"
                                        className="w-full  text-sm flex justify-center items-center"
                                        theme="blue"><span>ادامه</span></Button>
                            </div>
                        </BottomButtonWrapper>
                    </form>
                </div>
            </div>}
            {carCardStep === 2 && <div>

                <div className=" flex justify-center items-center   pb-5 w-full flex-col">
                    <img className="w-16 h-auto" src={UserInfoImage} alt=""/>
                    <span className="font-bold mt-2">اطلاعات مالک خوردو را وارد کنید.</span>

                </div>
                <div className=" p-3 flex flex-col items-start justify-start bg-white mb-28 rounded-lg">
                    <form onSubmit={UserInfoFormik.handleSubmit} className="w-full mt-5 ">
                        <div className="grid grid-cols-1 w-full gap-3 ">
                            {(!reset_step || reset_step === 'Shahkar' || processInfo.passed_steps.length === 0) && <>
                                <label className="text-sm" htmlFor="nid">کد ملی مالک خودرو</label>
                                <input dir="ltr" onChange={UserInfoFormik.handleChange}
                                       value={UserInfoFormik.values.nid}
                                       type="tel" className="w-full bg-gray-100 text-sm text-right rounded-xl p-3"
                                       placeholder="کد ملی مالک خودرو را وارد کنید"
                                       name="nid"/>
                                {UserInfoFormik.errors.nid && UserInfoFormik.touched.nid ? (
                                    <p className="text-red-400 text-sm font-light mt-1 ">{UserInfoFormik.errors.nid}</p>
                                ) : null}
                            </>}
                            { showInput('mobile',processInfo) && <>
                                <div className="w-full flex justify-between">
                                    <label className="text-sm" htmlFor="mobile">شماره موبایل مالک خودرو</label>
                                </div>
                                <input dir="ltr" onChange={UserInfoFormik.handleChange}
                                       disabled={isOwner}
                                       value={UserInfoFormik.values.mobile}
                                       type="tel" className={`w-full bg-gray-100 text-sm  text-right rounded-xl p-3 ${isOwner ? ' bg-gray-300':' bg-gray-100 '}`}
                                       placeholder="شماره موبایل مالک خودرو را وارد کنید"
                                       name="mobile"/>
                                {UserInfoFormik.errors.mobile && UserInfoFormik.touched.mobile ? (
                                    <p className="text-red-400 text-sm font-light mt-1 ">{UserInfoFormik.errors.mobile}</p>
                                ) : null}
                            </>}
                            {(!reset_step || reset_step === 'Shahkar') && <>
                                <div className="grid grid-cols-1 mt-1 border-t">
                                    <div onClick={() => {
                                        handleOwner(!isOwner)
                                    }} className="w-full  justify-between p-3   flex items-center">
                                        <span className="text-sm ">مالک خودرو هستم.</span>
                                        <Switch onColor="#36b570" height={20} width={40} uncheckedIcon={false} checkedIcon={false}
                                                checked={isOwner}
                                                onChange={handleOwner}/>
                                    </div>
                                    {<div className="w-full bg-blue-50 rounded-xl p-5 ">
                                        <p className="text-sm">
                                            در صورتی که شما مالک خودرو نباشید، کد اعتبارسنجی از طریق پیامک برای مالک خودرو ارسال خواهد شد.
                                        </p>
                                    </div>}


                                </div>
                            </>}


                        </div>

                        <BottomButtonWrapper grid={1}>

                            <div className={` justify-between grid gap-2 items-center ${'grid-cols-2'}`}>
                                <Button onClick={() => {
                                    setCarCardStep(1)
                                }} type="button" rounded="rounded-lg"
                                        className="w-full  text-sm flex justify-center items-center"
                                        theme="link"><span>مرحله قبل</span></Button>
                                <Button type="submit" rounded="rounded-lg"
                                        className="w-full  text-sm flex justify-center items-center"
                                        theme="blue"><span>مرحله بعد</span></Button>
                            </div>
                        </BottomButtonWrapper>
                    </form>
                </div>
            </div>}
        </div>
    }
    export default GetInfoCarInfo;